var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{staticClass:"width-full",class:{'is-error': !_vm.verified},attrs:{"placeholder":_vm.placeholder},on:{"change":_vm.handleChange},model:{value:(_vm.selfValue),callback:function ($$v) {_vm.selfValue=$$v},expression:"selfValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }